/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Copyemail1Inputs */

const en_btn_copyemail1 = /** @type {(inputs: Btn_Copyemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy email`)
};

/**
* | output |
* | --- |
* | "Copy email" |
*
* @param {Btn_Copyemail1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_copyemail1 = /** @type {((inputs?: Btn_Copyemail1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Copyemail1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_copyemail1(inputs)
});
export { btn_copyemail1 as "btn_copyEmail" }